// extracted by mini-css-extract-plugin
export var button = "_m2-2";
export var card = "_m2-0";
export var closeButtonContainer = "_m2-3";
export var iconContainer = "_m2-1";